module.exports = __webpack_public_path__ + "static/img/image_solutions_ime_03.8ee3d4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/image_solutions_ime_03.png
// module id = tPqT
// module chunks = 10